module.exports = "/_next/static/images/ConnectToLeadingData@2x-4efb6295f11e13aea6263c6ad40d57ac.png";